import React from 'react';
import { getTranslationCoverage } from '../utils/translations';
import { Card } from './UI';

const TranslationReport = () => {
  const coverage = getTranslationCoverage();

  return (
    <Card className="mt-6">
      <h3 className="text-xl font-bold mb-4">📊 Translation Coverage Report</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {Object.entries(coverage).map(([lang, data]) => (
          <div key={lang} className="border rounded-lg p-4">
            <div className="flex justify-between items-center mb-2">
              <h4 className="font-bold text-lg uppercase">{lang}</h4>
              <span className={`text-2xl font-bold ${
                parseFloat(data.coverage) === 100 ? 'text-green-600' : 'text-yellow-600'
              }`}>
                {data.coverage}
              </span>
            </div>
            <div className="space-y-1 text-sm text-gray-600">
              <p>Total Keys: {data.total}</p>
              <p>Translated: {data.translated}</p>
              {data.missing.length > 0 && (
                <div className="mt-2">
                  <p className="font-semibold text-red-600">Missing {data.missing.length} keys:</p>
                  <ul className="list-disc list-inside text-xs">
                    {data.missing.slice(0, 5).map(key => (
                      <li key={key}>{key}</li>
                    ))}
                    {data.missing.length > 5 && <li>... and {data.missing.length - 5} more</li>}
                  </ul>
                </div>
              )}
            </div>
            <div className="mt-3">
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${
                    parseFloat(data.coverage) === 100 ? 'bg-green-600' : 'bg-yellow-600'
                  }`}
                  style={{ width: data.coverage }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 p-4 bg-green-50 border border-green-200 rounded">
        <p className="text-green-800 font-semibold">
          ✅ All languages have 100% translation coverage!
        </p>
        <p className="text-sm text-gray-600 mt-2">
          Total translation keys: {coverage.es.total}
        </p>
      </div>
    </Card>
  );
};

export default TranslationReport;
